<template>
  <div>
    <b-row>
      <b-col  md="12" class="settings-panel">
        <div class="card">
          <div class="card-header text-center">
            Google Settings
          </div>
          <b-row>
            <b-col class="settings-panel-body googlesettings">
              <div cla ss="card-block">
                <b-form class="mb-0 d-flex">
                  <b-form-group id="exampleInputGroup1" label="Client ID" label-for="client_id" class="m-50 mr-2">
                    <b-form-input id="client_id" v-model="form.clientID" type="text" required placeholder="Enter Client ID">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group id="exampleInputGroup1" label="Client Secret" label-for="client_secret" class=" ">
                    <b-form-input id="client_secret" type="text" v-model="form.clientSecretKey" required placeholder="Enter Client Secret">
                    </b-form-input>
                  </b-form-group>
                </b-form>
                <hr class="mb-0">
                <div v-for="(menu,index) in settingsSubmenu" :key="index">
                  <component :is="menu.child_component"  :settings="menu.details" ></component>
                </div>
            </div>
            </b-col>
          </b-row>
          <div class="card-footer text-muted text-right">
            <b-btn variant="primary" @click="save" size="sm">Save Changes
              <spinner v-if="buttonLoaders.saveChanges" size="small" ></spinner>
            </b-btn>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "GoogleSettings",
  data() {
    return {
      form: {},
      buttonLoaders:{
        saveChanges:false
      },
    }
  },
  props: {
    settings: {
      type: Object,
      default: () => null
    },
    settingsSubmenu: {
      type: Array,
      default: () => null
    },
  },
  components: {
    googleAnalytics: () =>
      import(/* webpackChunkName: 'googleAnalytics/index' */ '@/components/addons/GoogleAnalytics/index').then(
        ({ SettingsMenu }) => SettingsMenu
      ),
    googlePageSpeed: () =>
      import(/* webpackChunkName: 'googlePageSpeed/index' */ '@/components/addons/GooglePageSpeed/index').then(
        ({ SettingsMenu }) => SettingsMenu
      ),
    googleSafeBrowsing: () =>
      import(/* webpackChunkName: 'googleSafeBrowsing/index' */ '@/components/addons/GoogleSafeBrowsing/index').then(
        ({ SettingsMenu }) => SettingsMenu
      ),
  },
  created() {
    if (typeof this.settings.googleSettings !== 'undefined' && this.settings.googleSettings != null) {
      this.form.clientID = this.settings.googleSettings.clientID;
      this.form.clientSecretKey = this.settings.googleSettings.clientSecretKey;
    }
  },
  methods: {
    save() {
      this.buttonLoaders.saveChanges = true;
      let payload = {};
      payload.requiredData = {
        updateSettingsAllV3: {
          googleSettings: this.form
        },
        getSettingsAllV3: 1
      };
      this.$store.dispatch("sendAction", payload).then(response => {
        this.buttonLoaders.saveChanges = false;
        this.$store.commit("SET_SETTINGS", response.data.getSettingsAllV3);
      });
    }
  }
};

</script>
<style>
</style>
